import React from 'react';
import { Text } from 'basis';
import { isFeatureOn } from 'featureToggles';
import { StyledTableRow, StyledTableCell } from './Styles';

export const OneTapDisclaimer = () => {
  if (!isFeatureOn('auOneTap')) return null;
  return (
    <Text margin="2 0 0 0">
      Our offer will be accepted immediately when you or an additional card holder activate or use the card we provide,
      add it to a digital wallet, draw on the account or authorise or make a transaction on the account.
    </Text>
  );
};

export const OneTapGeneralPurchasesDisclaimer = () => {
  if (!isFeatureOn('auOneTap')) return null;
  return (
    <Text>
      Available on general purchases of goods and services (not cash advances) at participating retailers subject to
      minimum spend in the one transaction and the terms of a Minimum Monthly Payment Plan. We will charge interest
      calculated using the Purchase Rate on any outstanding amount after the plan period ends.
    </Text>
  );
};

export const OneTapPaymentPlansSection = () => {
  if (!isFeatureOn('auOneTap')) return null;
  return (
    <>
      <StyledTableRow>
        <StyledTableCell flex={1.3}>6-60 months</StyledTableCell>
        <StyledTableCell flex={1}>
          <OneTapGeneralPurchasesDisclaimer />
        </StyledTableCell>
      </StyledTableRow>
      <Text textStyle="heading5" bold="medium" margin="1 0 0 0">
        Payment plans and offers
      </Text>
      <hr />
    </>
  );
};
